import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addCheckInOutApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addCheckInOut = createAsyncThunk('addCheckInOut', async (payload) => {
  return await addCheckInOutApi(payload);
});

const addCheckInOutSlice = createSlice({
  name: 'addCheckInOut', // Unique Name
  initialState,
  reducers: {
    addCheckInOutReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCheckInOut.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addCheckInOut.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addCheckInOut.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addCheckInOutReset } = addCheckInOutSlice.actions;

export default addCheckInOutSlice.reducer;
